import { useState } from "react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";

/** The Worker's prompt(): an optional note, then one write. The server re-checks the note's length. */
export function NoteDialog({
  label,
  title,
  description,
  failure,
  onSave,
}: {
  label: string;
  title: string;
  description: string;
  /** Fixed words for a failed save (the design's), in place of the server's message. */
  failure?: string;
  onSave: (note: string) => Promise<void>;
}) {
  const [open, setOpen] = useState(false);
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  return (
    <Dialog open={open} onOpenChange={(o) => { setOpen(o); setError(null); }}>
      <DialogTrigger asChild>
        <Button variant="outline" size="sm" onClick={(e) => e.stopPropagation()}>{label}</Button>
      </DialogTrigger>
      <DialogContent onClick={(e) => e.stopPropagation()}>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <Textarea rows={3} placeholder="Optional note" value={note} onChange={(e) => setNote(e.target.value)} />
        {error ? <p role="alert" className="text-sm">{error}</p> : null}
        <DialogFooter>
          <Button variant="outline" data-nonmutating onClick={() => setOpen(false)}>Cancel</Button>
          <Button
            disabled={busy}
            onClick={async () => {
              setBusy(true);
              try {
                await onSave(note);
                setOpen(false);
                setNote("");
              } catch (e) {
                setError(failure ?? (e instanceof Error ? e.message : String(e)));
              } finally {
                setBusy(false);
              }
            }}
          >
            Save
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
